<template>
    <div :style="messageColors" class="sc-message--system">
        <slot :message="data">
            <span
                v-html="processedText"
                style="word-break: break-word; max-width: 475px; font-family: Inter, sans-serif"
            />
            <span
                v-if="data.meta"
                :style="{ color: messageColors.color, fontFamily: 'Inter, sans-serif' }"
                class="sc-message--meta"
            >
                {{ data.meta }}</span
            >
        </slot>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "SystemMessage",
    props: {
        data: {
            type: Object,
            required: true,
        },
        messageColors: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
        processedText() {
            let text = this.data.text;
            const userIds = text.match(/\b[0-9a-fA-F]{24}\b/g);
            if (userIds) {
                userIds.forEach((id) => {
                    const user = this.users.find((user) => user._id === id);
                    if (user) {
                        text = text.replace(id, user.name);
                    }
                });
            }
            return text;
        },
    },
};
</script>

<style scoped>
.sc-message--system {
    padding: 9px 15px;
    border-radius: 20px;
    font-weight: 400;
    font-size: 10px;
    line-height: 1.4;
    -webkit-font-smoothing: antialiased;
    font-style: normal;
    background-color: #ffeeeb !important;
    color: #fd6144 !important;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    text-align: center;
    word-break: break-word;
    max-width: 100%;
    margin: 0 auto;
    font-family: Inter, sans-serif !important;
}

.sc-message--meta {
    font-size: 9px;
    margin-bottom: 0;
    margin-top: 6px;
    opacity: 0.6;
    text-align: center;
    color: #fd6144 !important;
    font-family: Inter, sans-serif !important;
}
</style>
